module.exports = __webpack_public_path__ + "static/img/20045B_1_R_20201118_fit.ec8b4d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20045B_1_R_20201118_fit.png
// module id = +biN
// module chunks = 0